import { useDispatch } from "react-redux";
import { IMapBounds, setBoundsMap, setBusStation, setStateMap, setViewPortMapMode, setZoomMap } from "../store/mapScreenSlce";
import { IBusStation } from "@/shared/types/busStaition";
import { openNavTab } from "../../../shared/components/NavTab/fuctionsControl";
import { getMapBoundsForBusstaintions } from "../utils/map";

function useMap() {
    const dispatch = useDispatch();

    function changeStateAndZoomMap(state: number[], zoom?: number) {
        dispatch(setStateMap(state));
        if (zoom) {
            dispatch(setZoomMap(zoom));
        }
    }

    function changeBoundsMap(data: IMapBounds) {
        dispatch(setBoundsMap(data));
    }

    async function selectBusStaition(data: IBusStation) {
        dispatch(setBusStation(data));
        changeStateAndZoomMap([Number(data.stop_latitude), Number(data.stop_longitude)], 17)
    }

    // function getMapForBusstaintions(busStations) {
    //     console.log(3)
    //     const bounds = getMapBoundsForBusstaintions(busStations);
    //     console.log(bounds[0])
    //     dispatch(setViewPortMapMode('bounds'))
    //     dispatch(setBoundsMap({ values: bounds.bounds, options: bounds.options }))
    // }

    return {
        changeStateAndZoomMap,
        selectBusStaition,
        changeBoundsMap,
        getMapBoundsForBusstaintions,
        //getMapForBusstaintions,
    }

}

export default useMap;